// Preferensi tema aplikasi + login, satu sumber.
export const THEME_PREF_KEY = 'mantraz_theme';
export const THEME_ATTR = 'data-theme';
export const AUTH_THEME_ATTR = 'data-auth-theme';
export const THEME_PREFS = ['light', 'dark', 'system'];

export function normalizePref(value) {
  return THEME_PREFS.includes(value) ? value : 'light';
}

export function resolveTheme(pref, osPrefersDark) {
  if (pref === 'system') return osPrefersDark ? 'dark' : 'light';
  return pref === 'dark' ? 'dark' : 'light';
}

const THEME_COLOR = { light: '#f3f7fd', dark: '#08192c' };

export function applyResolvedTheme(theme, root) {
  root.setAttribute(THEME_ATTR, theme);
  root.setAttribute(AUTH_THEME_ATTR, theme);
  const meta = root.ownerDocument?.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', THEME_COLOR[theme] || THEME_COLOR.light);
}

// Pasang listener MediaQueryList, fallback addListener buat Safari lama. Balikin fungsi buat lepas listenernya.
export function onMediaChange(mql, fn) {
  if (mql.addEventListener) {
    mql.addEventListener('change', fn);
    return () => mql.removeEventListener('change', fn);
  }
  if (mql.addListener) {
    mql.addListener(fn);
    return () => mql.removeListener(fn);
  }
  return () => {};
}
